import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { NewFormData } from '@/interfaces/components/clients/NewFormData';

interface Props {
  modelValue?: NewFormData;
  generalBusinessPostingGroups?: any[];
  customerPostingGroups?: any[];
  nonResidentFinancialSectors?: any[];
  capitalConnections?: any[];
  financialSectors?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingInformation',
  props: {
    modelValue: null,
    generalBusinessPostingGroups: null,
    customerPostingGroups: null,
    nonResidentFinancialSectors: null,
    capitalConnections: null,
    financialSectors: null
  },
  emits: [
  'update:generalBusinessPostingGroup',
  'update:customerPostingGroup',
  'update:nonResidentFinancialSector',
  'update:capitalConnection',
  'update:financialSector'
],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue?: NewFormData;
  generalBusinessPostingGroups?: any[];
  customerPostingGroups?: any[];
  nonResidentFinancialSectors?: any[];
  capitalConnections?: any[];
  financialSectors?: any[];
};






function getValue(key: keyof NewFormData) {
  const val = props.modelValue?.[key];
  return val != null ? String(val) : undefined;
}

function formatOptions(listProp: keyof Props) {
  return computed(() => {
    const list = props[listProp] as any[];
    return (list ?? []).map((item) => ({
      label: `(${item.code}) ${item.description}`,
      value: String(item.id),
    }));
  });
}

const formattedGeneralOptions = formatOptions('generalBusinessPostingGroups');
const formattedCustomerOptions = formatOptions('customerPostingGroups');
const formattedNonResidentOptions = formatOptions('nonResidentFinancialSectors');
const formattedCapitalOptions = formatOptions('capitalConnections');
const formattedFinancialSectorOptions = formatOptions('financialSectors');

return { __sfc: true,props, emit, getValue, formatOptions, formattedGeneralOptions, formattedCustomerOptions, formattedNonResidentOptions, formattedCapitalOptions, formattedFinancialSectorOptions }
}

})